import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import FormInput from '../../new_arch/components/FormInput/FormInput';

import Field from '../../lib/forms/Field';
import MinWordCount from '../../lib/forms/validators/MinWordCount';

const CompanyNameInput = ( {
	value,
	onChange,
	onValidationStatusChange,
	disabled,
	required
} ) => {
	const [ hadFocusOnce, setHadFocusOnce ] = useState( false );

	const formField = new Field( 'companyName', 'Company Name', value, [ new MinWordCount( 1 ) ] );

	const hasError = !!value && !formField.validate();

	const errorMessage = hasError && hadFocusOnce
		? formField.errors.first
		: null;

	const isValid = !!value && !hasError;

	useEffect(
		() => onValidationStatusChange( isValid ),
		[ isValid ]
	);

	return (
		<FormInput
			className="CompanyNameInput"
			name="companyName"
			value={value}
			onChange={onChange}
			placeholder="Enter Company Name"
			error={errorMessage}
			required={required}
			onFocus={() => setHadFocusOnce( true )}
			disabled={disabled}
			label="Company Name"
		/>
	);
};

CompanyNameInput.propTypes = {
	value: PropTypes.any,
	onChange: PropTypes.func,
	onValidationStatusChange: PropTypes.func,
	disabled: PropTypes.bool,
	required: PropTypes.bool
};

CompanyNameInput.defaultProps = {
	value: '',
	onChange: () => {},
	onValidationStatusChange: () => {},
	disabled: false,
	required: false
};

export default CompanyNameInput;
